import {RichText} from '@sdox/ui'

import type {XcNwBlock_BlockRichTextType_Fragment} from '@sdox/api'

export const BlockRichText = (props: XcNwBlock_BlockRichTextType_Fragment) => {
  return <RichText content={props.text} />
}
